import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { UserRole } from '@/types/enums';
import { ROUTES } from '@/constants/routes';

interface AdminRouteProps {
  children: React.ReactNode;
}

const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const { user } = useAuthStore();

  if (!user || user.role !== UserRole.ADMIN) {
    if (user?.role === UserRole.CUSTOMER) {
      return <Navigate to={ROUTES.MY_ORDERS} replace />;
    }
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
